<template>
  <div class="about" style="padding-top: 50px;">
    <Row>
      <Col span="24">
        <img class="banner" src="../../static/image/qiyebanner.png" alt />
      </Col>
    </Row>
    <div class="contenter">
      <ul>
        <li class="left">
          <h2>创立背景</h2>
          <p>互联网自1969年诞生至今，是人类文明迄今为止所见证的发展最快、竞争最激烈、创新最活跃、参与最普遍、渗透最广泛、影响最深远的技术产业领域，纵观人类历史无它可以比肩。</p>
          <p>
            从1986年时任高能物理所ALEPH组组长的吴为民从中国北京发出第一封国际电子邮件至今，互联网已在中国发展30多年，对中国经济发展起着举足轻重的作用。</br>
            1995 年，张树新创立首家互联网服务供应商——瀛海威，让老百姓进入互联网。</br> 2002年， 第二季度，搜狐率先宣布盈利，宣布互联网的春天已经来临。</br>
            2009年1月7日，工业和信息化部为中国移动、中国电信和中国联通发放3张第三代移动通信(3G)牌照，此举标志着中国移动互联网发展新篇章。</br>
            2014年11月，李克强出席首届世界互联网大会时指出，互联网是大众创业、万众创新的新工具。</br>
            2015年3月，全国两会上，全国人大代表马化腾提交了《关于以“互联网+”为驱动，推进我国经济社会创新发展的建议》的议案，表达了对经济社会创新的建议和看法。</br>
            “互联网+”代表着一种新的经济形态，传统企业与互联网深入融合进行产业升级，将极大的提升运作效率、服务质量从而促进企业业绩和利润增长。</br>
          </p>
          <div class="left_img">
            <img src="../../static/image/leftbj.png" alt />
          </div>
        </li>
        <li class="right">
          <div class="right_img">
            <img src="../../static/image/rightbj.png" alt />
          </div>
          <p>
            2017年10月，中共十九大制定了新时代中国特色社会主义的行动纲领和发展蓝图，提出要建设网络强国、数字中国、智慧社会，发展数字经济、共享经济，培育新增长点、形成新动能。</br>
            2018年是改革开放的第40年。在互联网+各行各业发展都在取得成效基础上，互联网+改革将提到议事日程上来。共享经济将成为共享发展、互联网与改革开放三者相结合的交集，成为互联网+改革的突破口。</br>
          </p>
          <p>在国家大趋势、新动能的行业大背景下，简云科技应运而生，致力于通过共享经济思维帮助合作客户解决互联网行业相关技术、知识、服务、能力、产品等相关需求，践行共享经济理念为合作客户提供有价值的商业能力共享服务，共享赋能合作企业降低时间成本和资金成本，让合作企业快速形成商业闭环、填充空缺、补齐短板专注目标、用心经营、轻装上阵轻松将企业做大、做强。</p>
        </li>
      </ul>
    </div>
    <div class="Word_mouth">
      <div class="jianyunpt">
        <p>成为口碑最好的技术平台</p>
      </div>
      <Row type="flex" justify="center" class="code-row-bg pt">
        <Col span="13">
          <span class="jianyuntext">
            简云科技的众多业务都与客户互联网业务的发展息息相关，成为受客户信赖和喜爱的诚信企业，是我们不变的愿景。我们致力于提供优质、
            安全的产品和服务，主动发掘客户的潜在需求；我们以开放的方式激励更多人参与创新，将新技术与卓越的商业模式相结合，不断创造出动
            人心弦的惊喜；我们高度重视客户体验和他们的意见，不断完善客户关系管理体系，与客户共同成长，并将这一过程视为成就卓越的价值
            所在。
          </span>
        </Col>
      </Row>
    </div>
    <xfck></xfck>
  </div>
</template>

<script>
import xfck from "./xfck.vue";
export default {
  name: "about",
  data() {
    return {
      msg: "关于我们"
    };
  },
  components: {
    xfck
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media (min-width: 1250px) {
  .anders {
    box-shadow: 1px 1px 10px #cccccc;
    position: absolute;
    left: -30%;
    top: 30%;
    width: 700px;
    height: 285px;
    background-color: rgba(255, 255, 255, 0.9);
  }
  .p-ader {
    /* padding-top: 40px; */
    width: 80%;
    margin: 0 auto;
    margin-top: 40px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 300;
    color: rgba(153, 153, 153, 1);
  }
  .main-img {
    width: 740px;
    height: 500px;
  }
}
@media (max-width: 1250px) {
  .anders {
    box-shadow: 1px 1px 10px #cccccc;
    position: absolute;
    left: -30%;
    top: 30%;
    width: 600px;
    height: 250px;
    background-color: rgba(255, 255, 255, 0.9);
  }
  .p-ader {
    width: 80%;
    margin: 0 auto;
    margin-top: 30px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 300;
    color: rgba(153, 153, 153, 1);
  }
  .main-img {
    width: 740px;
    height: 500px;
  }
}
.zjzz {
  margin: 5% 0%;
}
.kuang {
  width: 100%;
  margin-left: -15px;
}
.kuang:nth-child(2) {
  margin-left: 30px;
}
.jianyun-row {
  margin-top: 120px;
  height: 310px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.banner {
  width: 100%;
}
.jianyunimg > img {
  width: 300px;
  height: 300px;
}
.p-jianyun {
  font-size: 14px;
  font-family: MicrosoftYaHeiLight;
  font-weight: 300;
  text-indent: 2em;
  color: rgba(153, 153, 153, 1);
}
.p-jianyun {
  height: 311px;
}
.p-jianyun p {
  margin-top: 10px;
}
.p-jianyun p:nth-child(1) {
  margin-top: 0px;
}
.main-img {
  margin-top: 5%;
  width: 80%;
  height: 100%;
}
.pt {
  margin: 20px 0;
}
.jianyunpt {
  margin: 0 auto;
}
.jianyunpt p:nth-child(1) {
  font-size: 36px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  text-align: center;
}
.jianyuntext {
  /* width: 854px; */
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 32px;
}

.zz {
  margin: 60px 0px;
}
.zhengjian1 {
  width: 50%;
  position: absolute;
  top: 5%;
  left: 19%;
}
.zhengjian2 {
  width: 50%;
  position: absolute;
  top: 25%;
  left: 19%;
}
.zhengjian3 {
  width: 50%;
  position: absolute;
  top: 7%;
  left: 19%;
}
.Word_mouth {
  background: rgba(246, 246, 246, 1);
  padding: 60px 0;
}
ul,
li {
  list-style: none;
}
.contenter {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0;
  overflow: hidden;
}
.contenter .left {
  width: 50%;
  float: left;
}
.contenter .left h2 {
  font-size: 36px;
  color: #333333;
  font-weight: Regular;
  font-family: Microsoft YaHei;
}
.contenter .left p {
  font-size: 14px;
  color: #888888;
  font-weight: Light;
  margin: 20px 0;
}
.left_img {
  width: 100%;
  text-align: left;
}
.left_img img {
  width: 487px;
  height: 365px;
}
.contenter .right p {
  font-size: 14px;
  color: #888888;
  font-weight: Light;
  margin: 30px 0;
}
.right_img {
  width: 100%;
  text-align: right;
}
.right_img img {
  width: 487px;
  height: 365px;
}
.contenter .right {
  width: 50%;
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/about.vue